import { Column } from './column';
import { Row } from './row';
import { Table } from './table';

function getUniqueValues(table: Table<any>): Record<string, Set<any>> {
  const uniqueValuesByColumn: Record<string, Set<any>> = {};

  for (const column of table.columns) {
    const columnName = column.id;
    const uniqueValues = new Set(table.rows.map(row => row[columnName]));
    uniqueValuesByColumn[columnName] = uniqueValues;
  }

  return uniqueValuesByColumn;
}

function getTypeIconCombination(table: Table<any>): Map<string, number> {
  const iconMap = new Map<string, number>();

  for (const row of table.rows) {
    const typ: string = row['typ'] ?? '-';
    const icon: number = row['SysIcon'] ?? row['typ_icon'] ?? row['icon'] ?? 0;
    if (!iconMap.has(typ)) iconMap.set(typ, icon);
  }
  return iconMap;
}

export { Table, Column, Row, getUniqueValues, getTypeIconCombination };
